<template>
    <div class="verify">
        <ul class="menu_items">
            <li v-for="(n,i) in menu_items" @click="accountShow(i)" :class="{list_item: menuIndex==i}">{{n}}</li>
        </ul>
        <form class="not_content" v-if="isAccount">
            <input type="hidden" v-model="accountForm.n_reg">
            <ul class="gallery_menu">
                <li class="introduce">Hi,欢迎来到长鹿旅游休博园官网网站<br>完成绑定后登入更便捷</li>
                <li class="input">
                    <label>长鹿账号</label><input type="text" placeholder="已验证手机"
                                              v-model="accountForm.mobile"
                                              onkeyup="this.value=this.value.replace(/[^\d]/g,'')">
                </li>
                <li class="input">
                    <label>确认密码</label><input type="password" placeholder="6-12位字符，建议字母、数字和符号"
                                              v-model="accountForm.password">
                </li>
                <li>
                    <div class="verify_input">
                        <label>验证码</label><input type="text" placeholder="请输入验证码" v-model="accountForm.verify_code">
                    </div>
                    <span class="verify_box" @click="getAccountImg()"><img :src="accountImg" alt=""
                                                                             class="verify_img"></span>
                </li>
            </ul>
            <div class="protocol" style="display: none"><input type="checkbox" v-model="accountCheck" @change="clickMe"> 我已阅读并同意<span
                    class="login_protocol">《长鹿旅游休博园用户注册协议》</span>
            </div>
            <div class="n_submit" @click="accountSubmit()">提交</div>
        </form>
        <form class="used_content" v-else>
            <input type="hidden" v-model="noAccountFrom.reg">
            <ul class="gallery_menu">
                <li class="introduce">Hi,欢迎来到长鹿旅游休博园官网网站<br>完成绑定后登入更便捷</li>
                <li class="input">
                    <label>用户名</label>
                    <input type="text" placeholder="手机号码" v-model="noAccountFrom.mobile"
                           onkeyup="this.value=this.value.replace(/[^\d]/g,'')">
                </li>
                <li class="input">
                    <label>设置密码</label>
                    <input type="password" placeholder="6-12位字符，建议字母、数字和符号"
                           v-model="noAccountFrom.password">
                </li>
                <li class="input">
                    <label>确认密码</label>
                    <input type="password" placeholder="6-12位字符，建议字母、数字和符号"
                           v-model="noAccountFrom.pwdRepeat">
                </li>
                <li>
                    <div class="verify_input">
                        <label>验证码</label><input type="text" placeholder="请输入验证码" v-model="noAccountFrom.verify_code">
                    </div>
                    <span class="verify_box" @click="getNoAccountImg()"><img :src="noAccountImg" alt="" class="verify_img"></span>
                </li>
                <li>
                    <div class="verify_input"><label>手机验证码</label><input type="text" placeholder="请输入验证码"
                                                                         v-model="noAccountFrom.sms_code"></div>
                    <span class="phone_verify" @click="getPhone()" v-if="isGetCodeShow">发送验证码</span>
                    <span class="phone_verify" v-else>{{waitingTime}}(s)</span>
                </li>
            </ul>
            <div class="protocol" style="display: none"><input type="checkbox" v-model="accountCheck" @change="clickMe"> 我已阅读并同意<span
                    class="login_protocol">《长鹿旅游休博园用户注册协议》</span>
            </div>
            <div class="s_submit" @click="noAccountSubmit()">提交</div>
        </form>
    </div>

</template>

<script>
    export default {
        name: "verify",
        inject: ['showMsg'],
        data() {
            return {
                noAccountFrom: {
                    reg: 'reg',
                    mobile: '',
                    password: '',
                    pwdRepeat: '',
                    sms_code: '',
                    verify_code: ''
                },
                accountForm: {
                    n_reg: 'n_reg',
                    mobile: '',
                    password: '',
                    verify_code: ''
                },
                isAccount: true,
                menu_items: ['已有账号，请绑定', '没有账号，请完善'],
                menuIndex: 0,
                accountImg: '',
                noAccountImg: '',
                accountCheck: false,
                rag: /^1[0-9]{10}$/,
                isGetCodeShow: true,
                waitingTime: 120,

            }
        },
        created() {
            this.accountShow(0);
            this.getAccountImg();
        },
        methods: {
            accountShow(i) {
                this.menuIndex = i;
                this.isAccount = this.menuIndex == 0 ? true : false;
                this.accountCheck = false;
                if(i==0){
                    this.getAccountImg();
                }if(i==1){
                    this.getNoAccountImg();
                }
            },
            getAccountImg() {
                this.$http({
                    method: "post",
                    url: this.weburl + "home/User/verify",
                    dataType: "json",
                })
                    .then(res => {
                        this.accountImg = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            getNoAccountImg() {
                this.$http({
                    method: "post",
                    url: this.weburl + "home/User/verify",
                    dataType: "json",
                })
                    .then(res => {
                        this.noAccountImg = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            getPhone() {
                if (this.noAccountFrom.mobile == '') {
                    this.showMsg('手机号不能为空!');
                    return false;
                }
                if (!this.rag.test(this.noAccountFrom.mobile)) {
                    this.showMsg('手机格式不匹配!');
                    return false;
                }
                if (this.noAccountFrom.password.length < 6 || this.noAccountFrom.password.length > 20) {
                    this.showMsg('请输入6~20位的密码!');
                    return false;
                }
                if (this.noAccountFrom.password == '' || this.noAccountFrom.pwdRepeat == "") {
                    this.showMsg('密码不能为空!');
                    return false;
                }
                if (this.noAccountFrom.password != this.noAccountFrom.pwdRepeat) {
                    this.showMsg('密码不一致!');
                    return false;
                }
                if (this.noAccountFrom.verify_code == '') {
                    this.showMsg('验证码不能为空!');
                    return false;
                }
                this.$http({
                    method: "post",
                    url: this.weburl + "home/user/checkCode",
                    dataType: "json",
                    data: {
                        verify_code: this.noAccountFrom.verify_code,
                        username: this.noAccountFrom.mobile,
                        act: this.noAccountFrom.reg,
                    }
                })
                    .then(res => {
                        if (res.data.status == 1) {
                            this.sendCode()
                        } else {
                            this.showMsg(res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            sendCode() {
                this.$http({
                    method: "post",
                    url: this.weburl + "/index.php?m=Home&c=Api&a=send_validate_code&scene=1&type=mobile&mobile=" + this.noAccountFrom.mobile,
                    dataType: "json",
                    data: {
                        verify_code: this.noAccountFrom.verify_code,
                        username: this.noAccountFrom.mobile,
                        act: this.noAccountFrom.reg,
                    }
                })
                    .then(res => {
                        if (res.data.status == 1) {
                            this.isGetCodeShow = false;
                            this.countDown();
                            this.showMsg(res.data.msg);
                        } else {
                            this.showMsg(res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })

            },
            countDown: function () {
                this.stopWaiting = setInterval(() => {
                    this.waitingTime -= 1;
                }, 1000);
            },
            accountSubmit() {
                if(this.accountForm.mobile ==''){
                    this.showMsg('手机号不能为空!');
                    return false;
                }
                if(!this.rag.test(this.accountForm.mobile)){
                    this.showMsg('手机格式不匹配!');
                    return false;
                }
                if ( this.accountForm.password.length < 6 ||  this.accountForm.password.length > 20) {
                    this.showMsg('请输入6~20位的密码!');
                    return false;
                }
                if(this.accountForm.verify_code == ''){
                    this.showMsg('验证码不能为空!');
                    return false;
                }
               /* if(!this.accountCheck) {
                    this.showMsg('请查看用户协议！');
                    return false;
                }*/
                this.$http({
                    method: "post",
                    url: this.weburl + "home/user/bind_account",
                    dataType: "json",
                    data:this.accountForm,
                })
                    .then(res => {
                        if (res.data.status == 1) {
                            this.showMsg(res.data.msg);
                        } else {
                            this.showMsg(res.data.msg);
                            this.getAccountImg();
                        }
                    })
                    .catch(err => {
                        this.showMsg('请联系管理员');
                        this.getAccountImg();
                    })
            },
            noAccountSubmit() {
                /*if(!this.accountCheck) {
                    this.showMsg('请查看用户协议！');
                    return false;
                }*/
                this.$http({
                    method: "post",
                    url: this.weburl + "home/user/bind_reg",
                    dataType: "json",
                    data: this.noAccountFrom,
                })
                    .then(res => {
                        if (res.data.status == 1) {
                            this.showMsg(res.data.msg);
                        } else {
                            this.showMsg(res.data.msg);
                            this.getNoAccountImg();
                        }
                    })
                    .catch(err => {
                        this.showMsg('请联系管理员');
                        this.getNoAccountImg();
                    })
            },
            clickMe() {
                this.accountCheck = true;
            },

        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            },
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/less/common";

    .verify {
        padding: 10px 0;
        width: 100%;
        .menu_items {
            height: 35px;
            line-height: 35px;
            li {
                width: 50%;
                height: 100%;
                color: @brick_red;
                font-size: @font + .1;
                .border-bottom(3px; @bg);
                float: left;
                text-align: center;
                &.list_item {
                    .border-bottom(3px; @brick_red);
                }
            }
        }

    }

    .gallery_menu {
        width: 90%;
        margin: 24px auto;
        li {
            height: 45px;
            margin-bottom: 15px;
            &.input {
                width: @width;
                padding: 12px 5px;
                .box-sizing;
                .border(2px; solid; @bg);
                color: tint(@word, 50%);
            }
            &.introduce {
                background: @bg;
                font-size: @font - .1;
                line-height: @font;
                text-align: center;
                color: @word;
                padding-top: 14px;
            }
            & > input {
                font-size: @font - .1;
                margin-left: 15px;
                width: 69%;
            }
            & > label {
                width: 26%;
            }
            label {
                display: inline-block;
                color: @word;
                text-align: justify;
                text-align-last: justify;
            }
        }

    }

    .verify_input {
        float: left;
        width: 70%;
        padding: 10px 0 10px 5px;
        .box-sizing;
        .border(2px; solid; @bg);
        & > input {
            width: 55%;
            margin-left: 7%;
        }
        & > label {
            width: 36%;
        }
    }

    .verify_box, .phone_verify {
        float: left;
        height: 42px;
        width: 28%;
        margin-left: 2%;
    }

    .verify_box img {
        .img;
    }

    .phone_verify {
        line-height: 42px;
        text-align: center;
        background: @brick_red;
        color: @font-primary;
        font-size: @font - .1;
    }

    .protocol {
        padding-left: 5%;
        font-size: @font - .1;
        .login_protocol {
            color: @info;
        }
    }

    .s_submit, .n_submit {
        width: 36%;
        margin: 20px 32%;
        height: 40px;
        line-height: 40px;
        background: @subject_color;
        color: @font-primary;
        text-align: center;
    }


</style>
